import {
  DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT,DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT,DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT,

  DOCTEMPEDITOR_ON_START_GET_TEMPLATES, DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES, DOCTEMPEDITOR_ON_GET_TEMPLATES,
  DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES, DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES, DOCTEMPEDITOR_ON_DELETE_TEMPLATES,
  DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE, DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE, DOCTEMPEDITOR_ON_LOAD_TEMPLATE, 
  DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE,DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE,DOCTEMPEDITOR_ON_CREATE_TEMPLATE,
  DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE, DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE, DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE,
  DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT, DOCTEMPEDITOR_ON_LOAD_DOCUMENT,
  DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES, DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES, DOCTEMPEDITOR_ON_UPDATE_TEMPLATES,
  DOCTEMPEDITOR_ON_START_ADD_PAGE, DOCTEMPEDITOR_ON_ERROR_ADD_PAGE, DOCTEMPEDITOR_ON_ADD_PAGE,
  DOCTEMPEDITOR_ON_START_UPDATE_PAGE, DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE, DOCTEMPEDITOR_ON_UPDATE_PAGE,
  DOCTEMPEDITOR_ON_START_DELETE_PAGE, DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE, DOCTEMPEDITOR_ON_DELETE_PAGE,

	DOCTEMPEDITOR_ON_START_GET_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_GET_TEMPLATE_DYNAMIC_FIELD,
	DOCTEMPEDITOR_ON_START_DELETE_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_DELETE_TEMPLATE_DYNAMIC_FIELD,
	DOCTEMPEDITOR_ON_START_EDIT_TEMPLATE_DYNAMIC_FIELD,DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_EDIT_TEMPLATE_DYNAMIC_FIELD,
	DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD,DOCTEMPEDITOR_ON_CREATE_TEMPLATE_DYNAMIC_FIELD,

  DOCTEMPEDITOR_ON_START_ADD_SECTION, DOCTEMPEDITOR_ON_ERROR_ADD_SECTION, DOCTEMPEDITOR_ON_ADD_SECTION,
  DOCTEMPEDITOR_ON_START_UPDATE_SECTION, DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION, DOCTEMPEDITOR_ON_UPDATE_SECTION,
  DOCTEMPEDITOR_ON_START_DELETE_SECTION, DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION, DOCTEMPEDITOR_ON_DELETE_SECTION,

  DOCTEMPEDITOR_ON_START_UPDATE_COLUMN, DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN, DOCTEMPEDITOR_ON_UPDATE_COLUMN,
  DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE, DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE, DOCTEMPEDITOR_ON_CONVERT_TEMPLATE,

  DOCTEMPEDITOR_ON_START_GET_DOCUMENTS, DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS, DOCTEMPEDITOR_ON_GET_DOCUMENTS,
  DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS, DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS, DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS,
  DOCTEMPEDITOR_ON_START_DELETE_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_DELETE_DOCUMENT, DOCTEMPEDITOR_ON_DELETE_DOCUMENT,
  DOCTEMPEDITOR_ON_START_GET_DOCUMENT_STATS, DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS, DOCTEMPEDITOR_ON_GET_DOCUMENT_STATS,
  DOCTEMPEDITOR_ON_START_SEND_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT, DOCTEMPEDITOR_ON_SEND_DOCUMENT,
  DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT, DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT,
  DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE, DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE, DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE,
  DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS,
  DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS,
  DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS,
  DOCTEMPEDITOR_ON_GET_DOCUMENT_ATTACH,
  DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART,
  DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART,
  DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART, 
  DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART,
  DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART,
  DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART, 
  DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT_FROM_TEMP,
  DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP,
  DOCTEMPEDITOR_ON_CREATE_DOCUMENT_FROM_TEMP,  
  DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT,
  DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT,
  DOCTEMPEDITOR_ON_CREATE_DOCUMENT,
  DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS,
  DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS,
  DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS,

  DOCTEMPEDITOR_ON_START_ATTEST_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT, DOCTEMPEDITOR_ON_ATTEST_DOCUMENT,
 DOCTEMPEDITOR_ON_START_ADD_PRODUCTS_FROM_EXCEL, 
 DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL, 
 DOCTEMPEDITOR_ON_ADD_PRODUCTS_FROM_EXCEL, 
  DOCTEMPEDITOR_ON_START_LOAD_META,
  DOCTEMPEDITOR_ON_LOAD_META,
  DOCTEMPEDITOR_ON_ERROR_LOAD_META,
  ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,DOCTEMPEDITOR_ON_SET_CRESPONSE,
  ON_NEW_ORDER,ON_FETCH_CONTACT_FLAGS_BY_ID,
	ON_GET_START_ESIGNERING_PROCESS,
}  from '../constants/ActionTypes'
import { translate } from "../util/intlHelper";
import axios from 'util/Api' 
import { v4 as uuidv4 } from 'uuid';
import {history} from '../store'
import { isUndefined,isNull ,isEmpty} from 'lodash';
import {RefreshUserInterface, getKundAvtalProspekt, getKundKontakter,getEsignering,getProspektByUserid1,getOrderByIDRest1,createNewEvent } from 'actions'
import fileSaver from 'file-saver' 
import { generateAuthHeaders } from '../util/projektBasicAuthHelper';

export const createTemplateV2 = (Name, Type, Category, Afid, Userid, TempMallId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE})
    axios.post('docTemplate', {body: {
      Name, Type, Category, Afid, Userid, TempMallId: 0
    }
		},{
    headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
        history.push(
          {
            pathname: Type === "Mail" ? '/app/Konto/MailMall' : '/app/Konto/Mallv2',
            state: { 
              Tempid: data.Tempid
            }
          }
        )
				dispatch({type: DOCTEMPEDITOR_ON_CREATE_TEMPLATE})
      } else {
				dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE})
			}
      dispatch(RefreshUserInterface(Userid))
      console.log(data)
    }).catch(err => {
			dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE})
      console.log(err)
    })
  }
}
export const setPresetTemplate = (Afid, Userid, TempMallId, ThisMallId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE})
    axios.post('docTemplate/setPresetTemplate', {body: {
      Afid, Userid, TempMallId, ThisMallId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE})
        history.push(
          {
            pathname: '/app/Konto/Mallv2',
            state: { 
              Tempid: ThisMallId
            }
          }
        )
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE})
      }
      dispatch(RefreshUserInterface(Userid))
      console.log(data)
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE})
      console.log(err)
    })
  }
}
export const saveTemplateAsNew = (Afid, Userid, TempMallId, TempName = 'Ny mall') => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE})
    axios.post('docTemplate/saveTemplateAsNew', {body: {
      Afid, Userid, TempMallId, TempName
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE})
        history.push(
          {
            pathname: '/app/Konto/Mallv2',
            state: { 
              Tempid: data.Tempid
            }
          }
        )
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE})
      }
      dispatch(RefreshUserInterface(Userid))
      console.log(data)
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE})
      console.log(err)
    })
  }
}
export const saveDocumentAsNew = (Docid, Afid, Userid, UpdatePrices, PrisListId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT})
    axios.post('docTemplate/saveDocumentAsNew', {body: {
      Docid, Afid, Userid, UpdatePrices, PrisListId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
        history.push(
          {
            pathname: '/app/Dokument',
            state: { 
              Docid: data.newDocid ,
              UtkastFlag: 1
            }
          }
        )
        // dispatch(getDocument(Afid, Userid, data.newDocid ))
      }
      dispatch(RefreshUserInterface(Userid))
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteTemplateV2 = (Tempid, Type, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES })
    axios.delete('docTemplate', {params: {
      Afid, Userid, Tempid,Type
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success){ 
        dispatch(getTemplatesV2(Afid, Userid))
        dispatch({type: DOCTEMPEDITOR_ON_DELETE_TEMPLATES })
      }
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES })
      console.log(err)
    })
  }
}
export const deleteDocument = (Docid, Afid, Userid, Offset, PageSize, SearchString, FilterState, fromTableFlag, Orgnr, AvProId, DocumentTypesArray,StatusFilter ) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  const FromTableFlag = isUndefined(fromTableFlag) ? 0 : 1
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_DELETE_DOCUMENT })
    axios.delete('docTemplate/deleteDocument', {params: {
      Docid, Userid, Afid
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success){ 
        if(FromTableFlag === 1) {
          dispatch(getDocuments(Afid, Userid, Offset, PageSize, FilterState, Orgnr, AvProId, DocumentTypesArray, StatusFilter, SearchString))
          dispatch({type: DOCTEMPEDITOR_ON_DELETE_DOCUMENT })
          dispatch(getDocumentStats(Afid, Userid, FilterState, DocumentTypesArray))
        } else {
          // history.push(
          //   {
          //     pathname: '/app/v2/Offert',
          //   }
          // )
          history.goBack()
        }
      }
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_DOCUMENT })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_DOCUMENT })
      console.log(err)
    })
  }
}
export const getTemplate = (Tempid, Afid, Userid, orgnr, kontakt, Docid, attachFlag, fetchKalkyl = 0, OrderList = null, PlacementIndex = -1, refreshTemp = 0, refreshOption = 0) => {
  // console.log(data)
  let Orgnr = isUndefined(orgnr) ? 0 : orgnr
  let AttachFlag = isUndefined(attachFlag) ? 0 : 1
  let Kontakt = isUndefined(orgnr) ? '{}' : kontakt
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE, payload: {AttachFlag}})
    axios.get('docTemplate/load', {params: {
      Tempid, Afid, Userid, Orgnr, Kontakt, Docid, AttachFlag, fetchKalkyl, OrderList,PlacementIndex,refreshTemp, refreshOption
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
        dispatch({
          type: DOCTEMPEDITOR_ON_LOAD_TEMPLATE, 
          payload: {
            Template: data.Template, 
            AttachFlag,
            PlacementIndex, 
            SchablonList: data.SchablonList, 
            Document: data.Document, 
            KalkylJSON:data.KalkylJSON
          }
        })
        // history.push(
        //   {
        //     pathname: '/app/Konto/Mallv2',
        //     state: { 
        //       Template: data.Template
        //     }
        //   }
        // )
      } else { 
        console.log(data)
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE})
       }
       dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      if(err.response.status === 413) {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE, payload: err.response.data})
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE})
      }
    })
  }
}
export const getTemplatesV2 = (Afid, Userid, init = true) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_TEMPLATES, payload: {init} })
    axios.get('docTemplate', {params: {
      Afid, Userid
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_GET_TEMPLATES, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES })
      console.log(err)
    })
    
  }
}

export const updateTemplatev2ByMeta = (Afid, Userid, Meta, Value, Tempid, GetTempFlag, init = true, Type = "Offert") => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    axios.put('docTemplate', {body: {
      Afid, Userid, Meta, Value, Tempid, Type
    }
  },{
    headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) {
        if(!isUndefined(GetTempFlag)) dispatch(getTemplatesV2(Afid, Userid, init))
        dispatch({type: DOCTEMPEDITOR_ON_UPDATE_TEMPLATES, payload: data.results})
      }
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES })
      console.log(err)
    })
  }
}
export const docTempEditorAddPage = (Tempid, Page, Afid, Userid, Pages) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_ADD_PAGE })
    axios.post('docTemplate/addPage', {body: {
      Page, Afid, Userid, Tempid, Pages
    }
  },{
    headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_ADD_PAGE})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_PAGE})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_PAGE})
    })
  }
}
export const docTempEditorUpdatePage = (Page, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_PAGE })
    axios.put('docTemplate/updatePage', {body: {
      Page, Afid, Userid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_PAGE})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE})
    })
  }
}
export const docTempEditorMovePage = (Pages, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_PAGE })
    axios.put('docTemplate/movePage', {body: {
      Pages, Afid, Userid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_PAGE})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE})
    })
  }
}
export const docTempEditorDeletePage = (PageId, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_DELETE_PAGE })
    axios.delete('docTemplate/deletePage', {params: {
      Afid, Userid, PageId
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_DELETE_PAGE })
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE })
      console.log(err)
    })
  }
}

export const docTempEditorAddSection = (Section, Tempid, PageId, Afid, Userid, Sections) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_ADD_SECTION })
    axios.post('docTemplate/addSection', {body: {
      Section, Afid, Userid, Tempid, PageId, Sections
    }
  },{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_ADD_SECTION})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_SECTION})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_SECTION})
    })
  }
}
export const docTempEditorUpdateSection = (Section, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_SECTION })
    axios.put('docTemplate/updateSection', {body: {
      Section, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_SECTION})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION})
    })
  }
}
export const docTempEditorMoveSection = (Sections, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_SECTION })
    axios.put('docTemplate/moveSection', {body: {
      Sections, Afid, Userid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_SECTION})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION})
    })
  }
}
export const docTempEditorMoveSectionFromPage = (SectionId, PageId, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_SECTION })
    axios.put('docTemplate/moveSectionFromPage', {body: {
      SectionId, PageId, Afid, Userid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_SECTION})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION})
    })
  }
}
export const docTempEditorDeleteSection = (SectionId, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_DELETE_SECTION })
    axios.delete('docTemplate/deleteSection', {params: {
      Afid, Userid, SectionId
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_DELETE_SECTION })
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION })
      console.log(err)
    })
  }
}

export const docTempEditorUpdateColumn = (Column, Afid, Userid, _WidthArr) => {
  // console.log(data)
  let WidthArr = isUndefined(_WidthArr) ? [] : _WidthArr
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/updateColumn', {body: {
      Column, Afid, Userid, WidthArr
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorUpdateColumnType = (ColumnId, ColumnObj, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/updateColumnType', {body: {
      ColumnId, ColumnObj, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorUpdateColumnProductData = (ColumnId, ProductData, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/updateColumnProductData', {body: {
      ColumnId, ProductData, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}

export const docTempEditorUpdateProductHeaderWidth = (ColumnId, HeaderWidthArr, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/updateProductHeaderWidth', {body: {
      ColumnId, HeaderWidthArr, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorAddProductHeader = (ColumnId, Header, HeaderWidthArr, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/addProductHeader', {body: {
      ColumnId, Header, HeaderWidthArr, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorUpdateProductHeader = (ColumnId, HeaderId, cell, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/updateProductHeader', {body: {
			ColumnId, HeaderId, cell, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorRemoveProductHeader = (ColumnId, Header, HeaderWidthArr, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/removeProductHeader', {body: {
      ColumnId, Header, HeaderWidthArr, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorAddProductHeaderFilter = (ColumnId, HeaderId, FilterId, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/addProductHeaderFilter', {body: {
			ColumnId, HeaderId, FilterId, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorRemoveProductHeaderFilter = (ColumnId, HeaderId, FilterId, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/removeProductHeaderFilter', {body: {
			ColumnId, HeaderId, FilterId, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const docTempEditorUpdateColumnTableData = (ColumnId, TableData, Afid, Userid, Tempid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    axios.put('docTemplate/updateColumnTableData', {body: {
      ColumnId, TableData, Afid, Userid, Tempid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}

export const AddnewMallBranschV2 = (Kedja,Bransch,MallId, Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('docTemplate/newBransch', {
      method: 'PUT',
      body: {
        Kedja:Kedja,
        Bransch:Bransch,
        MallId:MallId
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewMallBranschV2: ", data);
      if (data.results) {
        dispatch(getTemplatesV2(Kedja,Userid))
      } else {
        dispatch(getTemplatesV2(Kedja,Userid))
      }
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplatesV2(Kedja,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 
export const AddnewMallDelaKontoV2 = (Kedja,DelaAfid,MallId, Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('docTemplate/delaKonto', {
      method: 'PUT',
      body: {
        Kedja:Kedja,
        DelaAfid:DelaAfid,
        MallId:MallId
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewMallDelaKontoV2: ", data);
      if (data.results) {
        dispatch(getTemplatesV2(Kedja,Userid))
      } else {
        dispatch(getTemplatesV2(Kedja,Userid))
      }
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplatesV2(Kedja,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 
 
 export const deletethisMallDelaKontoV2 = (chip,Kedja, Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('docTemplate/deleteDelaKonto', {
      method: 'PUT',
      body: {
        chip:chip,
        Kedja:Kedja,
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletethisMallDelaKontoV2: ", data);
      if (data.results) {
        dispatch(getTemplatesV2(Kedja,Userid))
      } else {
        dispatch(getTemplatesV2(Kedja,Userid))
      }
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplatesV2(Kedja,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 

export const AddnewMallKontoV2 = (Kedja,Afid,MallId,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.put('docTemplate/newKonto', {
      method: 'PUT',
      body: {
        Kedja:Kedja,
        Afid:Afid,
        MallId:MallId
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewMallKonto: ", data);
       if (data.results) {
         dispatch(getTemplatesV2(Kedja,Userid))
       } else {
         dispatch(getTemplatesV2(Kedja,Userid))
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch(getTemplatesV2(Kedja,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 
//deletethisMallKonto
export const deletethisMallKontoV2 = (chip,Kedja,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.put('docTemplate/deleteKonto', {
      method: 'PUT',
      body: {
        chip:chip,
        Kedja:Kedja,
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletethisMallKonto: ", data);
       if (data.results) {
         dispatch(getTemplatesV2(Kedja,Userid))
       } else {
         dispatch(getTemplatesV2(Kedja,Userid))
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch(getTemplatesV2(Kedja,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 
export const AddnewMallChildKonto= (Afid,ChildAfid,MallId,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.put('docTemplate/newChildKonto', {
      method: 'PUT',
      body: {
        ChildAfid:ChildAfid,
        Afid:Afid,
        MallId:MallId
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewMallChildKonto: ", data);
       if (data.results) {
        // dispatch(getTemplatesV2(Afid,Userid))
       } else {
       //  dispatch(getTemplatesV2(Afid,Userid))
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch(getTemplatesV2(Afid,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 
//deletethisMallKonto
export const deletethisMallChildKonto = (chip,Afid,Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     axios.put('docTemplate/deleteChildKonto', {
      method: 'PUT',
      body: {
        chip:chip,
        Afid:Afid,
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletethisMallChildKonto: ", data);
       if (data.results) {
       //  dispatch(getTemplatesV2(Afid,Userid))
       } else {
       //  dispatch(getTemplatesV2(Afid,Userid))
       }
       dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       dispatch(getTemplatesV2(Afid,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 

 export const deletethisMallBranschV2 = (chip,Kedja, Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('docTemplate/deleteBransch', {
      method: 'PUT',
      body: {
        chip:chip,
        Kedja:Kedja,
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletethisMallBransch: ", data);
      if (data.results) {
        dispatch(getTemplatesV2(Kedja,Userid))
      } else {
        dispatch(getTemplatesV2(Kedja,Userid))
      }
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplatesV2(Kedja,Userid))
       console.log("Error****:", error.message);
     });
   }
 } 


 export const convertToVersion2 = (OldTempid, Afid, Userid, SectionHeights) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE, payload: OldTempid })
    axios.post('docTemplate/convertToV2', {body: {
      OldTempid,Afid, Userid, SectionHeights
    }
  },{
    headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_CONVERT_TEMPLATE})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE})
    })
  }
}

 export const createDocumentUtkast = (Afid, Userid, Orgnr, AvProId, fromPageFlag, _kontakt, _tempid, OrderId = null, fetchKalkyl = 0, 
  OrderList = null, PrisListId = 0, ProspektData={AvtalsTyp:'', AvtalsOperator:''}, Aid = null,LeverantorKund='', FaltId = 0, Taggar = [], isDialer = 0, OfficeId = null) => {
  // console.log(data)
  const FromPageFlag = isUndefined(fromPageFlag) ? 'OffertFlag' : fromPageFlag
  const Kontakt = isUndefined(_kontakt) ? {FName: '', LName: '', Email: '', Tele: '',PersonNr:''} : _kontakt
  const Tempid = isUndefined(_tempid) ? 0 : _tempid

  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    localStorage.removeItem("docData")
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT})
    axios.post('docTemplate/createDocumentUtkast', {body: {
      Afid, Userid, Orgnr, AvProId, Kontakt, Tempid, OrderId, OrderList, PrisListId, ProspektData,Aid,LeverantorKund, FaltId, Taggar, OfficeId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) {
        if(isDialer === 1){
          localStorage.setItem('docData', JSON.stringify({
            Docid: data.Docid,
            UtkastFlag: 1,
            Kontakt,
            FromPageFlag,
            FromCreateDocument: 1,
            fetchKalkyl,
            OrderList,
          }));
          window.open('/app/Dokument', '_blank');
        }else{
        history.push(
          {
            pathname: '/app/Dokument',
            state: { 
              Docid: data.Docid,
              UtkastFlag: 1,
              Kontakt,
              FromPageFlag,
              FromCreateDocument: 1,
              fetchKalkyl,
              OrderList,
            }
          }
        )
        }
      } 
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
 export const createDocumentFromTemp = (Afid, Userid, Orgnr, AvProId, fromPageFlag, _kontakt, _tempid, OrderId = null, fetchKalkyl = 0) => {
  // console.log(data)
  const FromPageFlag = isUndefined(fromPageFlag) ? 'OffertFlag' : fromPageFlag
  const Kontakt = isUndefined(_kontakt) ? {FName: '', LName: '', Email: '', Tele: '',PersonNr:''} : _kontakt
  const Tempid = isUndefined(_tempid) ? 0 : _tempid
  
  function download(url, filename) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        fileSaver.saveAs(blob, filename);
    })
    .catch(console.error);
  }

  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT_FROM_TEMP})
    axios.post('docTemplate/createDocumentFromTemp', {body: {
      Afid, Userid, Orgnr, AvProId, Kontakt, Tempid, OrderId, 
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) {
        download(data.DocUrl,data.Name)
        dispatch({type: DOCTEMPEDITOR_ON_CREATE_DOCUMENT_FROM_TEMP})
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP})
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP})
      console.log(err)
    })
  }
}
 export const updateDocument = (Afid, Userid, AvProId, Kontakt, Docid, UtkastFlag, Name, 
  Deadline, Orgnr, Tempid, ProspektData, EsignFlag, KalkylJSON, inkMoms, svgGraphs, OrderId, 
  roofImages, Surcharge,Discount, CresponsePL, OrderFlag,isDelOrder = 0) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    const formData = new FormData()

    formData.append('Afid', Afid)
    formData.append('Userid', Userid)
    formData.append('AvProId', AvProId)
    formData.append('Kontakt', JSON.stringify(Kontakt))
    formData.append('Docid', Docid)
    formData.append('UtkastFlag', UtkastFlag)
    formData.append('Name', Name)
    formData.append('Deadline', Deadline)
    formData.append('Orgnr', Orgnr)
    formData.append('Tempid', Tempid)
    formData.append('ProspektData', JSON.stringify(ProspektData))
    formData.append('EsignFlag', EsignFlag)
    formData.append('KalkylJSON', KalkylJSON)
    formData.append('inkMoms', inkMoms)
    formData.append('svgGraphs', JSON.stringify(svgGraphs))
    formData.append('Surcharge', Surcharge)
    formData.append('Discount', Discount)
    formData.append('OrderFlag', OrderFlag)
    formData.append('OrderId', OrderId)
    formData.append('isDelOrder', isDelOrder)

    roofImages.forEach(file => formData.append('files[]', file));

    // dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT, payload: 'create'})
    dispatch({type: DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT, payload: isUndefined(CresponsePL) ? null : CresponsePL})
    axios.post('docTemplate/createDocument', 
      formData,
      {
      body: {
      Afid, 
      Userid, 
      AvProId, 
      Kontakt: JSON.stringify(Kontakt), 
      Docid, 
      UtkastFlag, 
      Name,
      Orgnr,
      ProspektData: JSON.stringify(ProspektData),
      Tempid, 
      Deadline, 
      EsignFlag,
      KalkylJSON,
      inkMoms,
      svgGraphs: JSON.stringify(svgGraphs),
      Surcharge,
      Discount,
      OrderFlag,
      OrderId,
      isDelOrder
    },headers: { 
      'content-type': 'multipart/form-data',
      'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
				if(EsignFlag === 1) {
          let EsigneringsType = isUndefined(data.results.BenchMarkProcess[0].type)?1:data.results.BenchMarkProcess[0].type
          console.log("EsigneringsType: ", data.results.BenchMarkProcess[0])
          console.log("EsigneringsType: ", data.results.BenchMarkProcess[0].type)
          console.log("EsigneringsType: ", EsigneringsType)
					dispatch({type: ON_GET_START_ESIGNERING_PROCESS})
					dispatch(getEsignering(Afid, Userid, data.results.esignId, true,EsigneringsType))
					return
				}
				if(OrderFlag === 1) {
					dispatch({type: ON_NEW_ORDER, payload: data.results});
					history.push({
						pathname: '/app/Orderkort',
						state: { OrderId: data.results.Order.Order[0] }
					});
					dispatch(getOrderByIDRest1(Orgnr,Afid,Userid, data.results.Order.Order[0].id))
					return
				}
				if(!isNull(data.results.OrderId) && !isUndefined(data.results.OrderId)) {
					dispatch({type: ON_NEW_ORDER, payload: data.results});
					history.push({
						pathname: '/app/Orderkort',
						state: { OrderId: data.results.Order.Order[0] }
					});
					return
				}
        dispatch({type: DOCTEMPEDITOR_ON_CREATE_DOCUMENT, payload: {...data.results, EsignFlag}})
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT, payload: data})
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      if(isUndefined(err.response)) dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT})
      else {
        if(err.response.status === 413) {
          dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT, payload: err.response.data})
        } else {
          dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT})
        }
      }
    })
  }
}
export const getDocument = (Afid, Userid, Docid, SaveData) => {
  // console.log(data)
  let SaveFlag = isUndefined(SaveData) ? 0 : 1
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT})
    axios.get('docTemplate/getDocument', {params: {
      Afid, Userid, Docid
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) {
        
        dispatch({type: DOCTEMPEDITOR_ON_LOAD_DOCUMENT, payload: {Document: data.results, SaveFlag, SchablonList: data.SchablonList  }})
        dispatch(getAttachDocument(Docid, Userid))

        if(SaveFlag === 1){
          let msPerSection = 50
          let ammoutOfSections = 0
          for(let page of data.results.Pages) {
            ammoutOfSections+=page.sections.length
          }

          setTimeout(() => {
            dispatch(updateDocument(
              SaveData.Afid,
              SaveData.Userid, 
              SaveData.AvProId, 
              SaveData.kontakt,
              SaveData.Docid, 
              SaveData.UtkastFlag,
              SaveData.DocName, 
              SaveData.Deadline, 
              SaveData.Orgnr, 
              SaveData.Tempid,
              SaveData.prodata,
              SaveData.EsignFlag,
              SaveData.KalkylJSON,
              SaveData.inkMoms,
              SaveData.svgGraphs,
              SaveData.OrderId,
              SaveData.roofImages,
              SaveData.Surcharge,
              SaveData.Discount
            ))
          }, (msPerSection * ammoutOfSections))
          
        }
      }
      else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT})
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT})
      console.log(err)
    })
  }
}

export const updateDocumentByMeta = (Afid, Userid, Meta, Value, Docid, Offset, PageSize, SearchString, FilterState, fromTableFlag,StatusFilter) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  const FromTableFlag = isUndefined(fromTableFlag) ? 0 : 1
  return(dispatch) => {
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    if(FromTableFlag === 0) dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateDocumentByMeta', {body: {
      Afid, Userid, Meta, Value, Docid
    }}, {headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success && FromTableFlag === 1){ 
          dispatch(getDocuments(Afid, Userid, Offset, PageSize, FilterState, undefined, undefined, undefined,StatusFilter, SearchString))
          dispatch({type: DOCTEMPEDITOR_ON_DELETE_DOCUMENT })
          dispatch(getDocumentStats(Afid, Userid, FilterState))
      } else {
        if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
        else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      }
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      console.log(err)
    })
  }
}
export const updateDocumentByMetaWFile = (Afid, Userid, Meta, Value, Docid, Files = []) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })

    const formData = new FormData()

    formData.append('Afid', Afid)
    formData.append('Userid', Userid)
    formData.append('Meta', Meta)
    formData.append('Value', Value)
    formData.append('Docid', Docid)

    if(!isEmpty(Files)) Files.forEach(file => formData.append('files[]', file));

    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateDocumentByMetaWFile', formData, 
    {
      body: {
        Afid, Userid, Meta, Value, Docid
      }},{
      headers: { 
        'Content-Type': 'multipart/form-data',
        'Authorization':`Bearer ${jwt}`
      }
    }).then(({data}) => {
      if(data.success){ 
          // if(SearchString === "") dispatch(getDocuments(Afid, Userid, Offset, PageSize, FilterState, undefined, undefined, undefined,StatusFilter))
          // else dispatch(searchDocuments(Afid, SearchString, Offset, PageSize, FilterState, Userid))
          // dispatch({type: DOCTEMPEDITOR_ON_DELETE_DOCUMENT })
          // dispatch(getDocumentStats(Afid, Userid, FilterState))
      }
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      console.log(err)
    })
  }
}
export const updateDocumentColumnByMeta = (Afid, Userid, Meta, Value, Docid, SectionId, ColumnId, Files = []) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    const formData = new FormData()

    formData.append('Afid', Afid)
    formData.append('Userid', Userid)
    formData.append('Meta', Meta)
    formData.append('Value', Value)
    formData.append('Docid', Docid)
    formData.append('SectionId', SectionId)
    formData.append('ColumnId', ColumnId)

    if(!isEmpty(Files)) Files.forEach(file => formData.append('files[]', file));
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateDocumentColumnByMeta', formData, 
    {
      body: {
        Afid, Userid, Meta, Value, Docid, SectionId, ColumnId
      },
      headers: { 
        'Content-Type': 'multipart/form-data',
        'Authorization':`Bearer ${jwt}`
      }
    }).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateDocumentProductdataByMeta = (Afid, Userid, Meta, Value, Docid, ColumnId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateDocumentProductdataByMeta', {body: {
      Afid, Userid, Meta, Value, Docid, ColumnId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateDocumentProductHeaderByMeta = (Afid, Userid, Meta, Value, Docid, ColumnId, HeaderId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {


    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    axios.put('docTemplate/updateDocumentProductHeaderByMeta', {body: {
      Afid, Userid, Meta, Value, Docid, ColumnId, HeaderId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateDocumentSectionByMeta = (Afid, Userid, Meta, Value, Docid, SectionId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    axios.put('docTemplate/updateDocumentSectionByMeta', {body: {
      Afid, Userid, Meta, Value, Docid, SectionId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateDocumentTablecellByMeta = (Afid, Userid, Meta, Value, Docid, ColumnId, rowId, cellId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})
    axios.put('docTemplate/updateDocumentTablecellByMeta', {body: {
      Afid, Userid, Meta, Value, Docid, ColumnId, rowId, cellId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateDocumentTablecellByMetaSendDocument = (Afid, Meta, Value, Docid, ColumnId, rowId, cellId) => {
  // console.log(data)
  // const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})
    axios.put('docTemplate/updateDocumentTablecellByMetaSendDocument', {body: {
      Afid, Meta, Value, Docid, ColumnId, rowId, cellId
    },
    // headers: { 'Authorization':`Bearer ${jwt}`}
  }).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateDocumentTemplateTablecellByMeta = (Afid, Userid, Meta, Value, Tempid, ColumnId, rowId, cellId,CId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_COLUMN })
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    axios.put('docTemplate/updateDocumentTemplateTablecellByMeta', {body: {
      Afid, Userid, Meta, Value, Tempid, ColumnId, rowId, cellId,CId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_UPDATE_COLUMN})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN})
    })
  }
}
export const updateDocumentPageByMeta = (Afid, Userid, Meta, Value, Docid, PageId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    // dispatch({type: DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES })
    axios.put('docTemplate/updateDocumentPageByMeta', {body: {
      Afid, Userid, Meta, Value, Docid, PageId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      
    }).catch(err => {
      console.log(err)
    })
  }
}

export const addProductToDocument = (Afid, Userid, ColumnId, Docid, Product) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.post('docTemplate/addProductToDocument', {body: {
      Afid, Userid, ColumnId, Docid, Product
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateProductsOrder = (Afid, Userid, ColumnId, Docid, Products) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductsOrder', {body: {
      Afid, Userid, ColumnId, Docid, Products
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const addProductsArrToDocument = (Afid, Userid, ColumnId, Docid, Products, PageId, SectionId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.post('docTemplate/addProductsArrToDocument', {body: {
      Afid, Userid, ColumnId, Docid, Products, PageId, SectionId
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const GetImportProductsExcel = () => {
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    axios.get('docTemplate/addProductsArrExcelToDocument/mall', 
      { params: {  }, 
      responseType: 'arraybuffer' ,
        headers: { 'Authorization':`Bearer ${jwt}`} }).then((resp) => {
          // console.log(resp)
          const dirtyFileName = resp.headers['content-disposition'];
          const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
          var  fileName = dirtyFileName.match(regex)[3];
          var blob = new Blob([resp.data], 
           { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
         );
         fileSaver.saveAs(blob, fileName);
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
    })
  }
}
export const addProductsArrToDocumentFromExcel = (Afid, Userid, ColumnId, Docid, PageId, SectionId, files) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    const formData = new FormData()

    if(!isEmpty(files)) files.forEach(file => formData.append('files[]', file));
    formData.append('Docid', Docid)
    formData.append('Afid', Afid)
    formData.append('Userid', Userid)
    formData.append('ColumnId', ColumnId)
    formData.append('PageId', PageId)
    formData.append('SectionId', SectionId)
    dispatch({type: DOCTEMPEDITOR_ON_START_ADD_PRODUCTS_FROM_EXCEL})

    axios.post('docTemplate/addProductsArrExcelToDocument',
      formData,
      {
        headers: { 
          'Authorization':`Bearer ${jwt}`,
          'Content-Type': 'multipart/form-data',
        }
      }).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_ADD_PRODUCTS_FROM_EXCEL, payload: {Document: data.results}})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL})
    })
  }
}
export const AttestDocumentById = (Afid, Userid, Docid, AttestStatus) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_ATTEST_DOCUMENT})
    axios.post('docTemplate/attestDocument',
			{
				body:{
					Afid, Userid, Docid, AttestStatus
				}
			},
      {
        headers: { 
          'Authorization':`Bearer ${jwt}`,
        }
      }).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_ATTEST_DOCUMENT, payload: {Document: data.results}})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT})
    })
  }
}


export const removeProductFromDocument = (Afid, Userid, ProductId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);

    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.delete('docTemplate/removeProductFromDocument', {params: {
      Afid, Userid, ProductId
    },headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)

			if(data.fetchAttachments) dispatch(getAttachDocument(data.Docid, Userid))

      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META}) 
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}

export const updateProductFromDocument = (Afid, Userid, ColumnId, Docid, Product) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductFromDocument', {body: {
      Afid, Userid, Product, ColumnId, Docid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
			if(data.fetchAttachments) dispatch(getAttachDocument(Docid, Userid))

      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateProductsFromDocument = (Afid, Userid, Docid, Products) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductsFromDocument', {body: {
      Afid, Userid, Products, Docid
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateProductsFromDocumentGront = (Afid, Userid, Products, Docid) => {
  // console.log(data)
  // const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {

    let headers = generateAuthHeaders(1)
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductsFromDocumentGront', {body: {
      Afid, Userid, Products, Docid
    }},{
      headers
    }).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}
export const updateProductFromDocumentByMeta = (Afid, Userid, Meta, Value, ProductId) => {
  // console.log(data)
  return(dispatch) => {

    let headers = generateAuthHeaders(1)
    // dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductFromDocumentByMeta', {body: {
      Afid, Userid, Meta, Value, ProductId
    }}, {headers}).then(({data}) => {
      // if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      // else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      // dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      console.log(err)
    })
  }
}
export const updateProductFromDocumentByMetaTextData = (Afid, Userid, Meta, Value, ProductId, TextDataValue, TextDataIndex, Docid) => {
  // console.log(data)
  return(dispatch) => {

    let headers = generateAuthHeaders(1)
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductFromDocumentByMetaTextData', {body: {
      Afid, Userid, Meta, Value, ProductId, TextDataValue, TextDataIndex,Docid
    }}, {headers}).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      console.log(err)
    })
  }
}
export const updateProductFromDocumentByMultiMeta = (Afid, Userid, MetaObj, ProductId) => {
  // console.log(data)
  return(dispatch) => {

    let headers = generateAuthHeaders(1)
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})

    axios.put('docTemplate/updateProductFromDocumentByMultiMeta', {body: {
      Afid, Userid, MetaObj, ProductId
    }}, {headers}).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      console.log(err)
    })
  }
}

export const addAttachDocument = (Afid, Userid, FileName, files, Docid, PlacementIndex = -1, document, opt, externLink) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()

    if(!isEmpty(files)) files.forEach(file => formData.append('files[]', file));
    formData.append('Docid', Docid)
    formData.append('Afid', Afid)
    formData.append('FileName', FileName)
    formData.append('Userid', Userid)
    formData.append('PlacementIndex', PlacementIndex)
    formData.append('document', JSON.stringify(document))
    formData.append('opt', opt)
    formData.append('externLink', externLink)

    
    dispatch({type: DOCTEMPEDITOR_ON_SET_CRESPONSE, payload: {type: 'info',
    show: true,
    loading: true,
    success: true,
    msg:  'Laddar upp bilaga'}})

    axios.post('docTemplate/addAttachDocument',
      formData,
      {
        body: {
          Docid: Docid,
          Afid: Afid,
          FileName: FileName,
          Docid: Docid,
          Userid: Userid,
          PlacementIndex: PlacementIndex,
          opt: opt,
          document: JSON.stringify(document),
          externLink: externLink
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      dispatch(getAttachDocument(Docid, Userid))
      console.log(data)
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_SET_CRESPONSE, payload: {type: 'success',
        show: true,
        loading: false,
        success: true,
        msg:  'Bilaga uppladdad'}})
      }
      else {
        dispatch({type: DOCTEMPEDITOR_ON_SET_CRESPONSE, payload: {type: 'error',
        show: true,
        loading: false,
        success: false,
        msg:  'Kunde inte ladda upp bilaga'}})
      }
    }).catch(err => {
    console.log(err.response.data)
    dispatch({type: DOCTEMPEDITOR_ON_SET_CRESPONSE, payload: {type: 'error',
        show: true,
        loading: false,
        success: false,
        msg:  err.response.data.error}})
    })
  }
}
export const getAttachDocument = (Docid, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('docTemplate/getAttachDocument', {params: {Docid,Userid}, headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      dispatch({type: DOCTEMPEDITOR_ON_GET_DOCUMENT_ATTACH, payload: data})
      // console.log(data)
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getSolelArtiklar = (Afid, Userid, PrisListId=0) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART })
    axios.get('docTemplate/getSolelArtiklar', {params: {Afid,Userid,PrisListId}, headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART})
      // console.log(data)
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART})
      console.log(err)
    })
  }
}
export const removeAttachDocument = (id, FileNameGc, Docid, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_META})
    axios.delete('docTemplate/removeAttachDocument', {params: {id, FileNameGc, Userid},headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      // dispatch({type: OFFERTPREV_ON_GET_BILAGOR, payload: data})
      dispatch(getAttachDocument(Docid, Userid))
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_META})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
      console.log(data)
    }).catch(err => {
      console.log(err)
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_META})
    })
  }
}

export const getDocuments = (Afid, Userid, Offset, PageSize, FilterState, Orgnr, AvProId, documentTypesArray, StatusFilter,SearchString) => {
  const DocumentTypesArray = isUndefined(documentTypesArray) ? JSON.stringify(['Offert', 'Avtal', '']) : JSON.stringify(documentTypesArray)
  SearchString=isUndefined(SearchString)?"":SearchString
  console.log(DocumentTypesArray)
  return (dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_DOCUMENTS})
    //dispatch({type: ON_START_MESSAGE_KUND,payload:"Hämtar Offertlista"});
    ////ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    const jwt =  JSON.parse(localStorage.token);
    axios.get('docTemplate/getDocuments', {params: {Afid, Userid, Offset, PageSize,FilterState, Orgnr, AvProId, DocumentTypesArray,StatusFilter,SearchString },headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_GET_DOCUMENTS, payload: data.results})
        //dispatch({type: ON_MESSAGE_KUND,payload:"Offertlista har hämtats"});
      }
      else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS})
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Error.Document.fetch")});
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS})
      dispatch({type: ON_MESSAGE_KUND,payload:translate("Error.Document.fetch")});
      console.log(err)
    })
  }
}
export const searchDocuments = (Afid, SearchString, Offset, PageSize, FilterState, Userid, documentTypesArray) => {
  const DocumentTypesArray = isUndefined(documentTypesArray) ? JSON.stringify(['Offert', 'Avtal', '']) : JSON.stringify(documentTypesArray)
  return (dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('docTemplate/searchDocuments', {params: {Afid, SearchString, Offset, PageSize,FilterState,Userid,DocumentTypesArray },headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS})
      console.log(err)
    })
  }
}
export const getDocumentStats = (Afid, Userid, FilterState, documentTypesArray) => {
  const DocumentTypesArray = isUndefined(documentTypesArray) ? JSON.stringify(['Offert', 'Avtal', '']) : JSON.stringify(documentTypesArray)
  return (dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_DOCUMENT_STATS})
    
    const jwt =  JSON.parse(localStorage.token);
    axios.get('docTemplate/getDocumentStats', {params: {Afid, Userid, FilterState, DocumentTypesArray },headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_GET_DOCUMENT_STATS, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS})
      console.log(err)
    })
  }
}

export const sendDocumentOrder = (Afid, Userid, Docid, Mottagare, ValidTime, Message, Subject) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_SEND_DOCUMENT})
    axios.post('docTemplate/sendDocumentOrder', {body: {
      Afid, Userid, Docid, Mottagare, ValidTime, Message, Subject
    }},{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_SEND_DOCUMENT, payload: data})
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT})
      }
      console.log(data)
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT})
      console.log(err)
    })
  }
}

export const sendDocument = (Afid, Userid, Docid, Mottagare, ValidTime, Message, Subject, buildParams, inviteToEvent, moteState,SMSState) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return async(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_SEND_DOCUMENT})
    const formData = new FormData()

    formData.append('Afid', buildParams.Afid)
    formData.append('Userid', buildParams.Userid)
    formData.append('AvProId', buildParams.AvProId)
    formData.append('Kontakt', JSON.stringify(buildParams.Kontakt))
    formData.append('Docid', buildParams.Docid)
    formData.append('UtkastFlag', buildParams.UtkastFlag)
    formData.append('Name', buildParams.Name)
    formData.append('Deadline', buildParams.Deadline)
    formData.append('Orgnr', buildParams.Orgnr)
    formData.append('Tempid', buildParams.Tempid)
    formData.append('ProspektData', JSON.stringify(buildParams.ProspektData))
    formData.append('EsignFlag', buildParams.EsignFlag)
    formData.append('KalkylJSON', buildParams.KalkylJSON)
    formData.append('inkMoms', buildParams.inkMoms)
    formData.append('svgGraphs', JSON.stringify(buildParams.svgGraphs))
    formData.append('Surcharge', buildParams.Surcharge)
    formData.append('Discount', buildParams.Discount)
    formData.append('OrderFlag', buildParams.OrderFlag)
    formData.append('OrderId', buildParams.OrderId)
    formData.append('ValidTime', ValidTime)
    formData.append('Mottagare', JSON.stringify(Mottagare))
    formData.append('Message', Message)
    formData.append('Subject', Subject)
    formData.append('SMSState', SMSState)

    buildParams.roofImages.forEach(file => formData.append('files[]', file));

    axios.post('docTemplate/sendDocument',formData,
    {
      body: {
        Afid, Userid, Docid, Mottagare, ValidTime, Message, Subject,SMSState
      },
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
      }
    }).then(({data}) => {
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_SEND_DOCUMENT, payload: data})
				if(inviteToEvent){
					console.log(moteState, 'moteState')
					moteState.Avtal = data.Document.AvProId
					moteState.Avtalid = data.Document.AvProId
					moteState.Kontakt.id = data.Document.KontaktId
        	dispatch(createNewEvent(Userid, Afid, moteState))
				}
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT})
      }
      console.log(data)
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT})
      console.log(err)
    })
  }
}

export const sentDocLog = (Token, Action) => {
  // console.log(data)
  return(dispatch) => {
    let headers = generateAuthHeaders(1)
    axios.post('docTemplate/sentDocLog', {body: {
      Token, Action
    },}, {headers: {
      ...headers
    }}).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const seenPageLog = (Token, Page) => {
  // console.log(data)
  return(dispatch) => {
    let headers = generateAuthHeaders(1)
    axios.post('docTemplate/seenPageLog', {body: {
      Token, Page
    },}, {headers: {
      ...headers
    }}).then(({data}) => {
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}

export const loadSentDocument = (Token) => {
  return (dispatch) => {
    let headers = generateAuthHeaders(1)
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT})
    axios.get('docTemplate/loadSentDocument', {params: {Token },headers: {
      ...headers
    }}).then(({data}) => {
      console.log(data)
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_LOAD_DOCUMENT, payload: {Document: data.results, SaveFlag: 0,  currentDocumentSentStatus:data.currentDocumentSentStatus}})
        dispatch({type: ON_FETCH_CONTACT_FLAGS_BY_ID, payload: {Flag: data.Flags}})
      }  
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT, payload: data.error})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT, payload: translate("Error.Document.fetch")})
      console.log(err)
    })
  }
}

export const sendDocumentInsertIntoTimeline = (Token, Status, StopGetDocument, message, svgGraphs = [], roofImages = []) => {
  // console.log(data)
  return(dispatch) => {

    let headers = generateAuthHeaders(1)
    const formData = new FormData()

    formData.append('Token', Token)
    formData.append('Status', Status)
    if(message) formData.append('message', message)
    formData.append('svgGraphs', JSON.stringify(svgGraphs))

    roofImages.forEach(file => formData.append('files[]', file));

    // dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT, payload: 'create'})

    axios.post('docTemplate/sendDocumentInsertIntoTimeline', 
    formData,
    {body: {
      Token, Status, message
    },headers: {'Content-Type': 'multipart/form-data',...headers}}).then(({data}) => {
      if(data.success && isUndefined(StopGetDocument)) {
        dispatch(loadSentDocument(Token))
      } else {
      }
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getCurrentDocumentSentStatusByDocid = (Docid) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE})
    axios.get('docTemplate/getCurrentDocumentSentStatusByDocid', {params: {Docid },headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      if(data.success)  dispatch({type: DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE})
      console.log(err)
    })
  }
}
// DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT, DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT,
export const PostMessageDocumentSentChat = (Afid, Userid, groupId, isSender, msg) => {
  // console.log(data)
  return(dispatch) => {
    let headers = generateAuthHeaders(1)
    dispatch({type: DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT})
    axios.post('docTemplate/PostMessageDocumentSentChat', {body: {
      Afid, Userid, groupId, isSender, msg
    }},{headers: {...headers}}).then(({data}) => {
      if(data.success) {
        dispatch({type: DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT, payload: {messages:data.results.messages, isSender}})
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT})

      }
      console.log(data)
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT})
      console.log(err)
    })
  }
}
//Jack 2023-03-07
export const getCurrentDocumentDocumentSentChat = (groupId) => {
  return (dispatch) => {
    let headers = generateAuthHeaders(1)
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT})
    axios.get('docTemplate/getChat', {params: {groupId },headers: {
      ...headers
    }}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT})
      console.log(err)
    })
  }
}

export const insertToDocumentSentTimelineByGroupId = (groupId, status, Userid, Afid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    axios.post('docTemplate/insertToDocumentSentTimelineByGroupId', {body: {
      groupId, status, Userid, Afid
    }},{headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) {
      } else {
      }
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const extendDueDateSendDocument = (groupId, DueDate, Userid, Afid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    axios.post('docTemplate/extendDueDateSendDocument', {body: {
      groupId, DueDate, Userid, Afid
    }},{headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) {
      } else {
      }
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getCustomFontColorsByAfid = (Userid, Afid) => {
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS})
    axios.get('docTemplate/getCustomFontColorsByAfid', {params: {Userid, Afid }},{headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS})
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS})
      console.log(err)
    })
  }
}

export const removeCustomFontColors = (ColorId, Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS })
    axios.delete('docTemplate/removeCustomFontColors', {params: {
      Afid, Userid, ColorId
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success){ 
        dispatch(getCustomFontColorsByAfid(Userid, Afid))
        dispatch({type: DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS })
      }
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS})
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS })
    })
  }
}

export const addCustomFontColors = (Userid, Afid, Hex) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS })
    axios.post('docTemplate/addCustomFontColors', {body: {
      Userid, Afid, Hex
    }},{headers: {
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) {
        dispatch(getCustomFontColorsByAfid(Userid, Afid))
        dispatch({type: DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS })
      } else {
        dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS })
      }
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS })
    })
  }
}
// DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS,
//   DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS,
//   DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS,
export const getProspectDocuments = (Afid, Userid, AvProId, Orgnr) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS })
    axios.get('docTemplate/prospectDocs', {params: {
      Afid, Userid,AvProId, Orgnr
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS })
      console.log(err)
    })
    
  }
}
export const getReferensArtiklar = (Afid, Userid, PrisListId=0) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART })
    axios.get('docTemplate/getReferensArtiklar', {params: {Afid,Userid,PrisListId}, headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':   `Bearer ${jwt}`
    }}).then(({data}) => {
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART, payload: data.results})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART})
      // console.log(data)
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART})
      console.log(err)
    })
  }
}


export const getTemplateDynamicFields = (Afid, Userid) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_GET_TEMPLATE_DYNAMIC_FIELD})
    axios.get('docTemplate/getTemplateDynamicFields', {params: {
      Afid, Userid
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_GET_TEMPLATE_DYNAMIC_FIELD, payload: data})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD })
      console.log(err)
    })
  }
}

export const deleteTemplateDynamicField = (Afid, Userid, FieldId) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_DELETE_TEMPLATE_DYNAMIC_FIELD})
    axios.delete('docTemplate/deleteTemplateDynamicField', {params: {
      Afid, Userid, FieldId
    },headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_DELETE_TEMPLATE_DYNAMIC_FIELD, payload: data})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD })
      console.log(err)
    })
  }
}

export const editTemplateDynamicField = (Afid, Userid, Field) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_EDIT_TEMPLATE_DYNAMIC_FIELD})
    axios.put('docTemplate/editTemplateDynamicField', {
      Afid, Userid, Field
    },{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_EDIT_TEMPLATE_DYNAMIC_FIELD, payload: data})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD })
      console.log(err)
    })
  }
}

export const createTemplateDynamicField = (Afid, Userid, Field) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return(dispatch) => {
    dispatch({type: DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE_DYNAMIC_FIELD})
    axios.post('docTemplate/createTemplateDynamicField', {
      Afid, Userid, Field
    },{headers: { 'Authorization':`Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      if(data.success) dispatch({type: DOCTEMPEDITOR_ON_CREATE_TEMPLATE_DYNAMIC_FIELD, payload: data})
      else dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD })
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD })
      console.log(err)
    })
  }
}
